// removed by extract-text-webpack-plugin
module.exports = {"dialog":"_3SJ5OpDsvpg7hT6XT9A5ap","active":"_2mYaWpt6bKqi0bsNFhT7-O","small":"_7FwgUDHgoy-cCc6eGWmox","normal":"_3wdPekt3Px6u8DFL0RwU2j","large":"_1U8l1JPZUvfLFlRHNaAbuW","fullscreen":"_3J5WrmEtx4Ax8-leodoTQK","title":"nlXNQRzMcXKO3J6Ys1jGs","body":"_3yg_yDUB4rJBcpcx8Cij2R","navigation":"UiuckPR44Ql7-l9NPbgba","button":"_2S986msTYMr9GznDycHO0f"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/dialog/theme.scss
// module id = 1001
// module chunks = 0